import { Link } from 'react-router-dom';
import { campaignHref, isExternalHref } from '../../utils/campaign';

/**
 * A campaign target is normally its own product page, but `external_link`
 * allows an absolute URL - which must not go through the router.
 */
const CampaignLink = ({ campaign, className = '', children, ...rest }) => {
  const href = campaignHref(campaign);

  if (isExternalHref(href)) {
    return (
      <a
        href={href}
        className={className}
        target="_blank"
        rel="noopener noreferrer"
        {...rest}
      >
        {children}
      </a>
    );
  }

  return (
    <Link to={href} className={className} {...rest}>
      {children}
    </Link>
  );
};

export default CampaignLink;
